import { useQuery } from '@tanstack/react-query'

import client from 'utils/client'
import URL from 'utils/url'


export default function useWebsiteGVL({ lang, websiteUUID }, options) {
  const url = URL.tcfGVL({
    lang,
    websiteUUID,
  })

  const cacheKey = ['website-gvl', websiteUUID]

  const {
    data = {},
    ...others
  } = useQuery({
    queryFn: () => client.get(url),
    queryKey: cacheKey,
    ...options,
  })

  return {
    ...others,
    websiteGVL: data.data,
  }
}

